import { Injectable } from '@angular/core';
import { AreaManagerShopModel } from './model/area-manager-shop.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AreaManagerShopService {

  constructor(private http: HttpClient) { }

  getShopList(requestData: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/area-manager/get-shops', requestData);

  }
  areaManagerList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/area-manager/get', requestData);

  }

  updateAreaManagerShops(assignments: any[]): Observable<any> {
    return this.http.post(environment.baseUrl + '/area-manager/update', { assignments });
  }

}
